import { render, staticRenderFns } from "./stats-table.vue?vue&type=template&id=0838f808&"
import script from "./stats-table.vue?vue&type=script&lang=js&"
export * from "./stats-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports